import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "panel", "iconPlus", "iconMinus"]
  static values = { open: { type: Boolean, default: false } }

  connect() {
    this.sync()
  }

  toggle() {
    this.openValue = !this.openValue
    this.sync()
  }

  sync() {
    if (!this.hasPanelTarget || !this.hasToggleTarget) return

    this.panelTarget.hidden = !this.openValue
    this.toggleTarget.setAttribute("aria-expanded", String(this.openValue))

    if (this.hasIconPlusTarget && this.hasIconMinusTarget) {
      this.iconPlusTarget.hidden = this.openValue
      this.iconMinusTarget.hidden = !this.openValue
    }
  }
}
